import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Mail, Lock, AlertCircle, CheckCircle } from 'lucide-react'
import Button from '../ui/Button'
import Input from '../ui/Input'
import { useAuth } from '../../context/AuthContext'

const SignupForm = ({ onSwitchToLogin }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: ''
  })
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const { signUp, loading } = useAuth()
  const navigate = useNavigate()

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
    setError('')
  }

  const validateForm = () => {
    if (!formData.email || !formData.password || !formData.confirmPassword) {
      setError('请填写所有必填字段')
      return false
    }

    if (formData.password !== formData.confirmPassword) {
      setError('密码确认不匹配')
      return false
    }

    if (formData.password.length < 6) {
      setError('密码长度至少为6位')
      return false
    }

    return true
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setSuccess(false)

    if (!validateForm()) return

    try {
      const result = await signUp(formData.email, formData.password)
      // 如果注册成功并且有session（无需邮箱确认），直接跳转
      if (result && result.session) {
        navigate('/dashboard')
      } else {
        // 否则显示邮箱确认提示
        setSuccess(true)
      }
    } catch (error) {
      setError(error.message || '注册失败，请稍后重试')
    }
  }

  if (success) {
    return (
      <div className="max-w-md mx-auto text-center">
        <div className="bg-green-50 border border-green-200 rounded-md p-6">
          <CheckCircle className="h-12 w-12 text-green-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-green-800 mb-2">
            注册成功！
          </h3>
          <p className="text-green-700 text-sm mb-4">
            请检查您的邮箱并点击确认链接来激活账户。
          </p>
          <Button
            onClick={onSwitchToLogin}
            variant="outline"
          >
            返回登录
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div className="max-w-md mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-gray-900">创建账户</h2>
        <p className="mt-2 text-gray-600">
          已有账户？{' '}
          <button
            onClick={onSwitchToLogin}
            className="text-primary-600 hover:text-primary-500 font-medium"
          >
            立即登录
          </button>
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-md p-4">
            <div className="flex items-center">
              <AlertCircle className="h-5 w-5 text-red-400 mr-2" />
              <span className="text-red-700 text-sm">{error}</span>
            </div>
          </div>
        )}

        <div>
          <Input
            label="邮箱地址"
            type="email"
            name="email"
            required
            value={formData.email}
            onChange={handleChange}
            placeholder="请输入邮箱地址"
          />
        </div>

        <div>
          <Input
            label="密码"
            type="password"
            name="password"
            required
            value={formData.password}
            onChange={handleChange}
            placeholder="请输入密码（至少6位）"
            helperText="密码长度至少为6位字符"
          />
        </div>

        <div>
          <Input
            label="确认密码"
            type="password"
            name="confirmPassword"
            required
            value={formData.confirmPassword}
            onChange={handleChange}
            placeholder="请再次输入密码"
          />
        </div>

        <Button
          type="submit"
          loading={loading}
          className="w-full"
        >
          注册账户
        </Button>
      </form>
    </div>
  )
}

export default SignupForm